interface BorderGateData {
  code: string;
  name: {
    [lang: string]: string;
  };
  type: string;
}

const thirdPartyData = [
  {
    maCk: "KBY",
    tenCK: "Cửa khẩu Bờ Y",
    tenCKEn: "Bo Y Landport",
    tenCKJa: "ボーイランドポート",
    tenCKKo: "보이랜드포트",
    tenCKZh: "博宜口岸",
    loai: "BO",
    maTT: "601",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CCP",
    tenCK: "Cảng Cẩm Phả",
    tenCKEn: "Cam Pha Seaport",
    tenCKJa: "カムファ港",
    tenCKKo: "캄파항",
    tenCKZh: "锦发港",
    loai: "BIEN",
    maTT: "225",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SCR",
    tenCK: "SBQT Cam Ranh",
    tenCKEn: "Cam Ranh Int Airport (Khanh Hoa)",
    tenCKJa: "カムラン国際空港",
    tenCKKo: "캄란국제공항",
    tenCKZh: "金兰国际机场",
    loai: "KHONG",
    maTT: "511",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SCT",
    tenCK: "SBQT Cần Thơ",
    tenCKEn: "Can Tho International Airport",
    tenCKJa: "カント国際空港",
    tenCKKo: "깐터국제공항",
    tenCKZh: "芹苴国际机场",
    loai: "KHONG",
    maTT: "815",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SCB",
    tenCK: "SBQT Cát Bi",
    tenCKEn: "Cat Bi Int Airport (Hai Phong)",
    tenCKJa: "カットビ国際空港",
    tenCKKo: "캣비국제공항",
    tenCKZh: "吉拜国际机场",
    loai: "KHONG",
    maTT: "103",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KCT",
    tenCK: "Cầu Treo",
    tenCKEn: "Cau Treo Landport",
    tenCKJa: "カウトレオランドポート",
    tenCKKo: "카우트레오랜드포트",
    tenCKZh: "高桥口岸",
    loai: "BO",
    maTT: "405",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KCL",
    tenCK: "Cửa khẩu Cha Lo",
    tenCKEn: "Cha Lo Landport",
    tenCKJa: "チャロランドポート",
    tenCKKo: "차로랜드포트",
    tenCKZh: "查罗口岸",
    loai: "BO",
    maTT: "407",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CCM",
    tenCK: "Cảng Chân Mây",
    tenCKEn: "Chan May Seaport",
    tenCKJa: "チャンメイ港",
    tenCKKo: "찬메이항",
    tenCKZh: "陈梅港",
    loai: "BIEN",
    maTT: "411",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SDN",
    tenCK: "SBQT Đà Nẵng",
    tenCKEn: "Da Nang International Airport",
    tenCKJa: "ダナン国際空港",
    tenCKKo: "다낭국제공항",
    tenCKZh: "岘港国际机场",
    loai: "KHONG",
    maTT: "501",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CDN",
    tenCK: "Cửa khẩu Cảng Đà Nẵng",
    tenCKEn: "Da Nang Seaport",
    tenCKJa: "ダナン港",
    tenCKKo: "다낭항",
    tenCKZh: "岘港港口",
    loai: "BIEN",
    maTT: "501",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SDH",
    tenCK: "Sân bay Đồng Hới",
    tenCKEn: "Dong Hoi Int Airport (Quang Binh)",
    tenCKJa: "ドンホイ国際空港",
    tenCKKo: "동호이국제공항",
    tenCKZh: "同和国际机场",
    loai: "KHONG",
    maTT: "407",
    regDate: "2017-11-08T10:20:27Z",
    lastUpdate: "2017-11-08T10:20:27Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CDQ",
    tenCK: "Cảng Dung Quất",
    tenCKEn: "Dung Quat Seaport",
    tenCKJa: "ドゥンクアット港",
    tenCKKo: "둥콰트항",
    tenCKZh: "荣山港",
    loai: "BIEN",
    maTT: "505",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CDO",
    tenCK: "Cảng Dương Đông",
    tenCKEn: "Duong Dong Seaport",
    tenCKJa: "ダウンドン港",
    tenCKKo: "두엉동항",
    tenCKZh: "阳东港",
    loai: "BIEN",
    maTT: "813",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KHT",
    tenCK: "Hà Tiên",
    tenCKEn: "Ha Tien Landport",
    tenCKJa: "ハティエンランドポート",
    tenCKKo: "하티엔랜드포트",
    tenCKZh: "河仙口岸",
    loai: "BO",
    maTT: "813",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CHP",
    tenCK: "Cảng Hải Phòng",
    tenCKEn: "Hai Phong Seaport",
    tenCKJa: "ハイフォン港",
    tenCKKo: "하이퐁항",
    tenCKZh: "海防港",
    loai: "BIEN",
    maTT: "103",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },

  {
    maCk: "CSG",
    tenCK: "Cảng TP.Hồ Chí Minh",
    tenCKEn: "Ho Chi Minh City Seaport",
    tenCKJa: "ホーチミン市港",
    tenCKKo: "호치민시항",
    tenCKZh: "胡志明市港口",
    loai: "BIEN",
    maTT: "701",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CHG",
    tenCK: "Cảng Hòn Gai",
    tenCKEn: "Hon Gai Seaport",
    tenCKJa: "ホンガイ港",
    tenCKKo: "혼가이항",
    tenCKZh: "洪盖港",
    loai: "BIEN",
    maTT: "225",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KHN",
    tenCK: "Hữu Nghị",
    tenCKEn: "Huu Nghi Landport",
    tenCKJa: "フーニーランドポート",
    tenCKKo: "후응히랜드포트",
    tenCKZh: "友谊口岸",
    loai: "BO",
    maTT: "209",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KLL",
    tenCK: "CK La Lay",
    tenCKEn: "La Lay Landport",
    tenCKJa: "ラレイランドポート",
    tenCKKo: "라레이랜드포트",
    tenCKZh: "拉雷口岸",
    loai: "BO",
    maTT: "409",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KLB",
    tenCK: "Lao Bảo",
    tenCKEn: "Lao Bao Landport",
    tenCKJa: "ラオバランドポート",
    tenCKKo: "라오바랜드포트",
    tenCKZh: "老坝口岸",
    loai: "BO",
    maTT: "409",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KLC",
    tenCK: "Lào Cai",
    tenCKEn: "Lao Cai Landport",
    tenCKJa: "ラオカイランドポート",
    tenCKKo: "라오카이랜드포트",
    tenCKZh: "老街口岸",
    loai: "BO",
    maTT: "205",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SLK",
    tenCK: "SBQT Liên Khương",
    tenCKEn: "Lien Khuong International Airport",
    tenCKJa: "リエン・クオン国際空港",
    tenCKKo: "리엔쿠엉국제공항",
    tenCKZh: "连琼国际机场",
    loai: "KHONG",
    maTT: "703",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KMB",
    tenCK: "Mộc Bài",
    tenCKEn: "Moc Bai Landport",
    tenCKJa: "モックバイランドポート",
    tenCKKo: "목바이랜드포트",
    tenCKZh: "木排口岸",
    loai: "BO",
    maTT: "709",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KMC",
    tenCK: "Móng Cái",
    tenCKEn: "Mong Cai Landport",
    tenCKJa: "モンカイランドポート",
    tenCKKo: "몽카이랜드포트",
    tenCKZh: "蒙凯口岸",
    loai: "BO",
    maTT: "225",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KNM",
    tenCK: "Cửa khẩu Na Mèo",
    tenCKEn: "Na Meo Landport",
    tenCKJa: "ナメオランドポート",
    tenCKKo: "나메오랜드포트",
    tenCKZh: "那苗口岸",
    loai: "BO",
    maTT: "401",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KNC",
    tenCK: "Cửa khẩu Nậm Cắn",
    tenCKEn: "Nam Can Landport",
    tenCKJa: "ナムカランドポート",
    tenCKKo: "남칸랜드포트",
    tenCKZh: "南坎口岸",
    loai: "BO",
    maTT: "403",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CNS",
    tenCK: "Cảng Nghi Sơn",
    tenCKEn: "Nghi Son Seaport",
    tenCKJa: "ギソン港",
    tenCKKo: "응히선항",
    tenCKZh: "义孙港口",
    loai: "BIEN",
    maTT: "401",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CNT",
    tenCK: "Cảng Nha Trang",
    tenCKEn: "Nha Trang Seaport",
    tenCKJa: "ニャチャン港",
    tenCKKo: "냐짱항",
    tenCKZh: "芽庄港口",
    loai: "BIEN",
    maTT: "511",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SNB",
    tenCK: "Sân bay Nội Bài",
    tenCKEn: "Noi Bai Int Airport",
    tenCKJa: "ノイバイ国際空港",
    tenCKKo: "노이바이국제공항",
    tenCKZh: "内排国际机场",
    loai: "KHONG",
    maTT: "101",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SPB",
    tenCK: "Sân bay Phú Bài",
    tenCKEn: "Phu Bai Int Airport",
    tenCKJa: "フーバイ国際空港",
    tenCKKo: "푸바이국제공항",
    tenCKZh: "富拜国际机场",
    loai: "KHONG",
    maTT: "411",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SPC",
    tenCK: "Sân bay Phù Cát",
    tenCKEn: "Phu Cat Int Airport",
    tenCKJa: "フーカット国際空港",
    tenCKKo: "푸캇국제공항",
    tenCKZh: "富吉国际机场",
    loai: "KHONG",
    maTT: "507",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SPQ",
    tenCK: "SBQT Phú Quốc",
    tenCKEn: "Phu Quoc International Airport",
    tenCKJa: "フーコック国際空港",
    tenCKKo: "푸꾸옥국제공항",
    tenCKZh: "富国国际机场",
    loai: "KHONG",
    maTT: "813",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CQN",
    tenCK: "Cảng Quy Nhơn",
    tenCKEn: "Quy Nhon Seaport",
    tenCKJa: "クイニョン港",
    tenCKKo: "꾀이넌항",
    tenCKZh: "归仁港口",
    loai: "BIEN",
    maTT: "507",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "STS",
    tenCK: "SBQT Tân Sơn Nhất",
    tenCKEn: "Tan Son Nhat Int Airport (Ho Chi Minh City)",
    tenCKJa: "タンソンニャット国際空港（ホーチミン市）",
    tenCKKo: "탄손녓국제공항(호치민시)",
    tenCKZh: "新山一国际机场（胡志明市）",
    loai: "KHONG",
    maTT: "701",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KTR",
    tenCK: "Cửa khẩu Tây Trang",
    tenCKEn: "Tay Trang Landport",
    tenCKJa: "テイトランドポート",
    tenCKKo: "테이틀랜드포트",
    tenCKZh: "台庄口岸",
    loai: "BO",
    maTT: "302",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KTB",
    tenCK: "CK Tịnh Biên",
    tenCKEn: "Tinh Bien Landport",
    tenCKJa: "ティンビエン陸上港",
    tenCKKo: "틴비엔육상항",
    tenCKZh: "亭边陆港",
    loai: "BO",
    maTT: "805",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "SVD",
    tenCK: "Sân bay Vân Đồn",
    tenCKEn: "Van Don Int Airport",
    tenCKJa: "バンドン国際空港",
    tenCKKo: "반돈국제공항",
    tenCKZh: "文顿国际机场",
    loai: "KHONG",
    maTT: "225",
    regDate: "2017-11-08T10:20:27Z",
    lastUpdate: "2017-11-08T10:20:27Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KVX",
    tenCK: "CK Vĩnh Xương",
    tenCKEn: "Vinh Xuong Landport",
    tenCKJa: "ヴィンシュオン陸上港",
    tenCKKo: "빈쑤엉육상항",
    tenCKZh: "永祥陆港",
    loai: "BO",
    maTT: "805",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CVA",
    tenCK: "Cảng Vũng Áng",
    tenCKEn: "Vung Ang Seaport",
    tenCKJa: "ブンアング港",
    tenCKKo: "붕앙항",
    tenCKZh: "武阳港",
    loai: "BIEN",
    maTT: "405",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "CVT",
    tenCK: "Cảng Vũng Tàu",
    tenCKEn: "Vung Tau Seaport",
    tenCKJa: "ブンタウ港",
    tenCKKo: "붕타우항",
    tenCKZh: "冯头港",
    loai: "BIEN",
    maTT: "717",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  },
  {
    maCk: "KXM",
    tenCK: "CK Xa Mát",
    tenCKEn: "Xa Mat Landport",
    tenCKJa: "ザマット陸上港",
    tenCKKo: "자마트육상항",
    tenCKZh: "下马陆港",
    loai: "BO",
    maTT: "709",
    regDate: "2016-12-23T15:27:20Z",
    lastUpdate: "2016-12-23T15:27:30Z",
    closeDate: null,
    cap: "",
    xncEvisa: 1
  }
];

const borderGatesData: BorderGateData[] = thirdPartyData.map((item) => ({
  code: item.maCk,
  name: {
    en: item.tenCKEn,
    jp: item.tenCKJa,
    kr: item.tenCKKo,
    cn: item.tenCKZh
  },
  type: item.loai
}));

export default borderGatesData;
